import React, { Component } from 'react'
import { LayoutPlain, Header, Footer } from 'components/layout'
import { ForgottenPasswordForm } from 'containers/forms/auth'

export default class ForgottenPassword extends Component {
  render() {
    return (
      <LayoutPlain
        header={<Header />}
        footer={<Footer />}
        body={[<ForgottenPasswordForm />]}
        colWidth='305px'
      />
    )
  }
}
